import type { ComponentProps } from 'react';
import { Link } from 'react-router-dom';

type RouterLinkProps = ComponentProps<typeof Link>;

type PrefetchLinkProps = RouterLinkProps & {
  LinkComponent?: typeof Link;
};

/** Router link — prefetch disabled; `React.lazy` owns chunk loading (shared `lazyPages.ts`). */
export function PrefetchLink({ LinkComponent = Link, ...rest }: PrefetchLinkProps) {
  return <LinkComponent {...rest} />;
}
